import { combineReducers } from 'redux'
import { user } from './user'
import { numPlayers, onlinePlayers } from './numPlayers'
import { socket } from './socket'
import { newVersion } from './newVersion'
import { connected } from './connected'
import { currentToken } from './currentToken'
import {users} from './users'
import { dice } from './dice'
import {game} from './game'
import {selected} from './selected'
import {result} from './result'
import { numImprovisers } from './numImprovisers'
import {miniDB} from './miniDB'

const blip = (state = null, action) => state

export default combineReducers({
    socket,
    user,
    numPlayers,
    numImprovisers,
    newVersion,
    connected,
    currentToken,
    users,
    blip,
    dice,
    miniDB,
    game,
    selected,
    result,
})


// WEBPACK FOOTER //
// ./src/reducers/quizApp.js